import { ErrorHandler, Injectable, Injector, NgZone } from "@angular/core";
import { ErrorLogService, UtilitesService } from "@systemic/services";
import { Router, ActivatedRoute } from "@angular/router";
import * as StackTraceParser from 'error-stack-parser';
import { LocationStrategy } from "@angular/common";
import { RouterExtService } from "../services/router/router-ext.service";
import { mlApiError } from "../services/http/http.service";


@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  public router: Router;
  public location: LocationStrategy;
  private route: ActivatedRoute;
  private routeExt: RouterExtService;
  constructor(injector: Injector, private zone: NgZone, private errorLogService: ErrorLogService

  ) {
    super();
    setTimeout(() => {
      this.router = injector.get(Router);
      this.location = injector.get(LocationStrategy);
      this.routeExt = injector.get(RouterExtService);
      this.route = injector.get(ActivatedRoute);
    });
  }
  handleError(error) {
    if (!(error instanceof mlApiError) && !(error.error instanceof mlApiError)) {
      // window.console.clear();
      console.log('*********************************************************************************');
      console.log(error);
      console.log(StackTraceParser.parse(error));
      console.log(this.routeExt.getCurrentUrl, this.routeExt.getPreviousUrl);
      console.log('*********************************************************************************');

      this.errorLogService.logError(error);
      if (this.routeExt.getCurrentUrl != '/error') {
        this.zone.run(() => this.router.navigate(['/error'], {
          queryParams: { err: true, rtu: this.routeExt.getCurrentUrl, gbu: this.routeExt.getPreviousUrl }
        }));
      }

    }
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/handlers/error-handler.ts